import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { SimpleSelect } from 'react-selectize';
import 'react-selectize/dist/index.css';
import FontAwesome from 'react-fontawesome';
import classNames from 'classnames';

import {
  compulsoryDropdown,
  dropdownOption,
  dropdownOptionTitle,
  dropdownOptionSubText,
  dropdownValue,
  toggleButton,
  dropdownDescription,
} from './styles.scss';
import { InputLabel } from '../../../InputLabel/component';

// This basically just wraps SimpleSelect from react-selectize and overrides its styles to match OL
export class SingleSelect extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    label: PropTypes.node,
    error: PropTypes.string,
    description: PropTypes.node,
    required: PropTypes.bool,
    autoSave: PropTypes.bool,
    disabled: PropTypes.bool,
    autoSaveState: PropTypes.string,
    placeholder: PropTypes.string,
  };

  static defaultProps = {
    className: null,
    label: null,
    error: null,
    description: null,
    required: false,
    autoSave: false,
    disabled: false,
    autoSaveState: null,
    placeholder: '',
  };

  renderToggleButton = ({ open }) =>
    open ? (
      <FontAwesome className={toggleButton} name="caret-up" />
    ) : (
      <FontAwesome className={toggleButton} name="caret-down" />
    );

  renderOption = (item) => {
    return (
      <div className={dropdownOption}>
        {item.title && (
          <span className={dropdownOptionTitle}>{item.title}</span>
        )}
        <span>{item.label}</span>
        {item.subText && (
          <span className={dropdownOptionSubText}>{item.subText}</span>
        )}
      </div>
    );
  };

  renderValue = (item) => {
    return (
      <div className={dropdownValue}>
        {item.title && (
          <span className={dropdownOptionTitle}>{item.title}</span>
        )}
        <span>{item.label}</span>
        {item.subText && (
          <span className={dropdownOptionSubText}>{item.subText}</span>
        )}
      </div>
    );
  };

  render() {
    const {
      className,
      label,
      error,
      description,
      required,
      autoSave,
      autoSaveState,
      placeholder,
      ...otherProps
    } = this.props;
    return (
      <div className={classNames('single-select', className)}>
        {label && (
          <InputLabel
            error={error}
            required={required}
            autoSave={autoSave}
            autoSaveState={autoSaveState}
          >
            {label}
          </InputLabel>
        )}
        {description && (
          <span className={dropdownDescription}>{description}</span>
        )}
        <SimpleSelect
          placeholder={placeholder}
          className={classNames(compulsoryDropdown)}
          hideResetButton
          renderToggleButton={this.renderToggleButton}
          renderOption={this.renderOption}
          renderValue={this.renderValue}
          {...otherProps}
        />
      </div>
    );
  }
}
